import styled from 'styled-components';

import { Col, CuiTheme } from '@crehana/ui';

export const StyledImage = styled.div`
  height: 440px;
  width: 120vw;
  transform: translate(-10vw);
  object-position: center right;
  > div {
    object-position: inherit;
  }
  @media (min-width: 540px) {
    width: 560px;
    margin-left: auto;
    margin-right: auto;
    transform: translateX(0px);
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
    height: 512px;
    width: 700px;
    object-position: bottom;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    height: 450px;
    width: 70vw;
    max-width: 700px;
    transform: none;
    object-position: center;
  }
  @media (min-width: 1366px) {
    right: -160px;
    z-index: 3;
    height: 90vh;
    max-height: 720px;
    min-height: 600px;
    max-width: 900px;
    width: 900px;
  }
  @media (min-width: 1440px) {
    right: 0px;
    width: 760px;
    max-width: 760px;
    object-position: top left;
  }
  @media (min-width: 1920px) {
    width: 1000px;
    max-width: 1000px;
  }
`;

export const StyledSection = styled.section`
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-height: 840px;
  }
  ::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 250px;
    background-color: white;
    ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('sm')} {
      height: 150px;
    }
    ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
      height: 100%;
      width: 380px;
      top: 0;
      left: auto;
    }
    @media (min-width: 1366px) {
      width: 500px;
    }
    @media (min-width: 1440px) {
      width: 590px;
    }
    @media (min-width: 1600px) {
      width: 680px;
    }
  }
`;

export const TextContainer = styled.div`
  max-width: 500px;
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('md')} {
    max-width: 400px;
  }
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    max-width: 550px;
    > h1 {
      font-size: 80px;
      line-height: 85px;
    }
    > h2 {
      padding-right: 32px;
    }
  }
`;

export const StyledCol = styled(Col)`
  ${({ theme }: { theme: CuiTheme }) => theme.breakpoints.up('lg')} {
    ::before {
      content: '';
      height: 100%;
      width: 40%;
      left: 0;
      top: 0;
      bottom: 0;
      position: absolute;
      background-color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;
